import React from 'react';
import { Alert, Badge, Card } from 'react-bootstrap';
export default function ClaimerPreviewErrors(_ref) {
  let {
    aifReportData
  } = _ref;
  if (!aifReportData.errors || !Array.isArray(aifReportData.errors) || aifReportData.errors.length === 0) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  return /*#__PURE__*/React.createElement(Card, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Card.Header, {
    className: "bg-danger text-white"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "mb-0"
  }, "Errors (", aifReportData.errors.length, ")")), /*#__PURE__*/React.createElement(Card.Body, null, aifReportData.errors.map((error, index) => /*#__PURE__*/React.createElement(Alert, {
    key: index,
    variant: "danger",
    className: "mb-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-start"
  }, /*#__PURE__*/React.createElement("div", {
    className: "me-2"
  }, /*#__PURE__*/React.createElement(Badge, {
    bg: "dark"
  }, "#", index + 1)), /*#__PURE__*/React.createElement("div", {
    className: "flex-grow-1"
  }, /*#__PURE__*/React.createElement("p", {
    className: "mb-0",
    style: {
      color: 'white'
    }
  }, error)))))));
}